import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Clear } from "@mui/icons-material";
import { color } from "../../../StyleData/Config";
import { axiosPrivate } from "../../../axios/axios";
import { masterAPI } from "../dataConfig";
import ErrorProps from "../../../Component/Errorprops";
import { toast } from "react-toastify";
const MeterModal = ({ mode, handleCloseClick, editData }) => {
  const [meterGroup, setmeterGroup] = useState([]);
  const [uomId, setUomId] = useState([]);
  const [meterType, setMeterType] = useState([]);
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    getData()
  }, []);


  const sourceList = [
    {
      value: "Manual",
      text: "Manual"
    },
    {
      value: "handheldAnalyser",
      text: "Handheld Analyser"
    },
    {
      value: "scada",
      text: "SCADA"
    }, 
    {
      value: "iotsensor",
      text: "IoT Sensor"
    }
  ]

  const getData = async () => {
    setLoading(true)
    const link = masterAPI["meterGroup"].link;
    const meterType = masterAPI["selectList"].metertypes;
    const uomLink = masterAPI["selectList"].uomByCat;
    await axiosPrivate
      .get(`${link}`)
      .then((res) => {
        setLoading(false)
        setmeterGroup(res.data.result);
      })
      .catch((e) => {
        setmeterGroup([])
        console.log(e, "createmeterGroup");
      });
    await axiosPrivate
    await axiosPrivate
      .get(`${uomLink}/Meter`)
      .then((res) => {
        setLoading(false)
        setUomId(res.data);
      })
      .catch((e) => {
        setUomId([])
        console.log(e, "createUom(Meter)");
      });
    await axiosPrivate
    await axiosPrivate
      .get(`${meterType}`)
      .then((res) => {
        setLoading(false)
        setMeterType(res.data);
      })
      .catch((e) => {
        setMeterType([])
        console.log(e, "(Metertype)");
      });
  }

  const initialValue = {
    meterName: mode === "Edit" ? editData.meterName : "",
    meterGroupId: mode === "Edit" ? editData.meterGroupId : "",
    uomId: mode === "Edit" ? editData.uomId : "",
    code: mode === "Edit" ? editData.code : "",
    metertype: mode === "Edit" ? editData.metertype : "",
    source: mode === "Edit" ? editData.source : "Manual",
    rangeFrom: mode === "Edit" ? editData.rangeFrom : "",
    rangeTo: mode === "Edit" ? editData.rangeTo : "",
    warningAbove: mode === "Edit" ? editData.warningAbove : "",
    warningBelow: mode === "Edit" ? editData.warningBelow : "",
    alarmAbove: mode === "Edit" ? editData.alarmAbove : "",
    alarmBelow: mode === "Edit" ? editData.alarmBelow : "",
    // allowValues: mode === "Edit" ? editData.allowValues : "", 
    // alarmValues: mode === "Edit" ? editData.alarmValues : ""
    // readEveryDays:mode==="Edit"?editData.readEvery: "",
    // serviceEvery:mode==="Edit"?editData.serviceEvery: ""
  };

 
  const onSubmit = async (value) => {
    console.log(value);
    setLoading(true)
    const createLink = masterAPI["meter"].create;
    const updateLink = masterAPI["meter"].update
  
    if (mode === "Create") {
      await axiosPrivate.post(`${createLink}`, value).then(res => {
        console.log(res.data)
        setLoading(false)
        handleCloseClick()
      }).catch(e => {
        setLoading(false)
        // toast.error(e.response.data.failureMessage)
        console.log(e, "createMeter")
        // toast.error(e.response.data.failureMessage)
        console.log(e, "createMeter")
      })
    }  else {
      const updateAC = {
        id: editData.id,
        ...value
      }
      await axiosPrivate.put(`${updateLink}`, updateAC).then(res => {
        console.log(res.data)
        setLoading(false)
        handleCloseClick()
      }).catch(e => {
      
        setLoading(false)
        if (e.response.data.FailureMessage) {
          // toast.error("Code is already exists")
        }
        console.log(e, "updateMeter")
        if (e.response.data.FailureMessage) {
          // toast.error("Code is already exists")
        }
        console.log(e, "updateMeter")
      })
    }
  

  };

  const handleCancel = () => {
    handleCloseClick();
  };
  const validationSchema = Yup.object().shape({
   code: Yup.string().required("Code is required"),
    meterName: Yup.string().required("Name is required"),
    meterGroupId: Yup.string().required("Meter Group is required"),
    uomId: Yup.string().required("UOM is required"),
  });
    
  return (
    <Box sx={{ p: color.masterPageDialogPadding }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            color: color.masterDialogTitleColor,
            fontSize: color.masterDialogFontSize,
          }}
        >
          {mode === "Edit" ? editData.code + "-" + editData.meterName : "New Meter"}
          {mode === "Edit" ? editData.code + "-" + editData.meterName : "New Meter"}
        </Typography>
        <IconButton onClick={handleCancel}>
          <Clear />
        </IconButton>
      </Box>
      <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
      <Formik initialValues={initialValue} validationSchema={validationSchema} onSubmit={onSubmit}>
        {({ handleChange, setFieldValue, values, resetForm }) => (
          <Form>
            <Grid container spacing={"1rem"}>
              <Grid item xs={12} md={12}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Meter Code
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="code"
                  placeholder="Enter Meter Code"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",
               
                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
                <ErrorMessage name="code">{(error) => <ErrorProps>{error}</ErrorProps>}</ErrorMessage>
              </Grid>
              <Grid item xs={12} md={12}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Meter Name
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="meterName"
                  placeholder="Enter Meter Name"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",
               

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
                <ErrorMessage name="meterName">{(error) => <ErrorProps>{error}</ErrorProps>}</ErrorMessage>
              </Grid>

             

              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Meter Group
                  Meter Group
                </Typography>
                <Field
                  as={Select}
                  // label={"Select"}
                  size={"small"}
                  type="text"
                  name="meterGroupId"
                  fullWidth
                  displayEmpty
                  MenuProps={{ PaperProps: { sx: { maxHeight: "40vh" } } }}
                  renderValue={
                    values.meterGroupId !== ""
                      ? undefined
                      : () => <Typography sx={{ color: color.placeholderColor, fontSize: "13px" }}>Select</Typography>
                  }
                >
                  {meterGroup.map((id, i) => (
                    <MenuItem value={id.id}>{id.meterGroupName}</MenuItem>
                  ))}
                </Field>
                <ErrorMessage name="meterGroupId">{(error) => <ErrorProps>{error}</ErrorProps>}</ErrorMessage>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  UOM
                  UOM
                </Typography>
                <Field
                  as={Select}
                  // label={"Select"}
                  size={"small"}
                  type="text"
                  name="uomId"
                  fullWidth
                  displayEmpty
                  MenuProps={{ PaperProps: { sx: { maxHeight: "40vh" } } }}
                  renderValue={
                    values.uomId !== ""
                      ? undefined
                      : () => <Typography sx={{ color: color.placeholderColor, fontSize: "13px" }}>Select</Typography>
                  }
                >
                  {uomId.map((id, i) => (
                    <MenuItem value={id.value}>{id.text}</MenuItem>
                  ))}
                </Field>
                <ErrorMessage name="uomId">{(error) => <ErrorProps>{error}</ErrorProps>}</ErrorMessage>
              </Grid>
            
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Meter Type
                </Typography>
                <Field
                  as={Select}
                  // label={"Select"}
                  size={"small"}
                  type="text"
                  name="metertype"
                  fullWidth
                  displayEmpty
                  MenuProps={{ PaperProps: { sx: { maxHeight: "40vh" } } }}
                  renderValue={
                    values.metertype !== ""
                      ? undefined
                      : () => <Typography sx={{ color: color.placeholderColor, fontSize: "13px" }}>Select</Typography>
                  }
                >
                  {meterType.map((id, i) => (
                    <MenuItem value={id.value}>{id.text}</MenuItem>
                  ))}
                </Field>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Source
                </Typography>
                <Field
                  as={Select}
                  // label={"Select"}
                  size={"small"}
                  type="text"
                  name="source"
                  fullWidth
                  displayEmpty
                  MenuProps={{ PaperProps: { sx: { maxHeight: "40vh" } } }}
                  renderValue={
                    values.source !== ""
                      ? undefined
                      : () => <Typography sx={{ color: color.placeholderColor, fontSize: "13px" }}>Select</Typography>
                  }
                >
                  {sourceList.map((id, i) => (
                    <MenuItem value={id.value}>{id.text}</MenuItem>
                  ))}
                </Field>
              </Grid>

              {/* Temporary hide fields */}
              {/* <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Read Every (days)*
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="number"
                  name="readEveryDays"
                  placeholder="Enter Read Every"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
                 <ErrorMessage name="readEvery">{(error) => <ErrorProps>{error}</ErrorProps>}</ErrorMessage>
              </Grid>
               <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Service every (continuous only)
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="number"
                  name="serviceEvery"
                  placeholder="Enter Service Every"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
                 <ErrorMessage name="serviceEvery">{(error) => <ErrorProps>{error}</ErrorProps>}</ErrorMessage>
              </Grid> */}
              {values.metertype.toLowerCase() === "gauge" && (
                <>
                  <Grid item xs={12} md={6} >
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Warning above (gauge)
                    </Typography>
                    <Field
                      as={TextField}
                      size={"small"}
                      type="number"
                      name="warningAbove"
                      placeholder="Enter Warning Above"
                      fullWidth
                      sx={{
                        ".MuiInputBase-input": {
                          // letterSpacing: "0.2rem",

                          "&::placeholder": {
                            // color: "green",
                            opacity: 1,
                            color: color.placeholderColor,
                            fontSize: "13px",
                          },
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} >
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Alarm above (gauge)
                    </Typography>
                    <Field
                      as={TextField}
                      size={"small"}
                      type="number"
                      name="alarmAbove"
                      placeholder="Enter Alarm Above"
                      fullWidth
                      sx={{
                        ".MuiInputBase-input": {
                          // letterSpacing: "0.2rem",

                          "&::placeholder": {
                            // color: "green",
                            opacity: 1,
                            color: color.placeholderColor,
                            fontSize: "13px",
                          },
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} >
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Warning below (gauge)
                    </Typography>
                    <Field
                      as={TextField}
                      size={"small"}
                      type="number"
                      name="warningBelow"
                      placeholder="Enter Warning Below"
                      fullWidth
                      sx={{
                        ".MuiInputBase-input": {
                          // letterSpacing: "0.2rem",

                          "&::placeholder": {
                            // color: "green",
                            opacity: 1,
                            color: color.placeholderColor,
                            fontSize: "13px",
                          },
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} >
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Alarm below (gauge)
                    </Typography>
                    <Field
                      as={TextField}
                      size={"small"}
                      type="number"
                      name="alarmBelow"
                      placeholder="Enter Alarm Below"
                      fullWidth
                      sx={{
                        ".MuiInputBase-input": {
                          // letterSpacing: "0.2rem",

                          "&::placeholder": {
                            // color: "green",
                            opacity: 1,
                            color: color.placeholderColor,
                            fontSize: "13px",
                          },
                        },
                      }}
                    />
                  </Grid>

                  {/* Temporary hide field */}
                  {/* <Grid item xs={12} md={6} >
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Allowed values, one per line (characteristic only)
                    </Typography>
                    <Field
                      as={TextField}
                      size={"small"}
                      type="text"
                      name="allowedValues"
                      placeholder="Enter Allowed Values"
                      fullWidth
                      multiline
                      minRows={1}
                      maxRows={12}
                      sx={{
                        ".MuiInputBase-input": {
                          // letterSpacing: "0.2rem",

                          "&::placeholder": {
                            // color: "green",
                            opacity: 1,
                            color: color.placeholderColor,
                            fontSize: "13px",
                          },
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} >
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Values that raise an alarm, one per line
                    </Typography>
                    <Field
                      as={TextField}
                      size={"small"}
                      type="text"
                      name="alarmValues"
                      placeholder="Enter Alarm Values"
                      fullWidth
                      multiline
                      minRows={1}
                      maxRows={12}
                      sx={{
                        ".MuiInputBase-input": {
                          // letterSpacing: "0.2rem",

                          "&::placeholder": {
                            // color: "green",
                            opacity: 1,
                            color: color.placeholderColor,
                            fontSize: "13px",
                          },
                        },
                      }}
                    />
                  </Grid> */}
                  <Grid item xs={12} md={6} >
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Range From
                    </Typography>
                    <Field
                      as={TextField}
                      size={"small"}
                      type="number"
                      name="rangeFrom"
                      placeholder="Enter Range From"
                      fullWidth
                      sx={{
                        ".MuiInputBase-input": {
                          // letterSpacing: "0.2rem",

                          "&::placeholder": {
                            // color: "green",
                            opacity: 1,
                            color: color.placeholderColor,
                            fontSize: "13px",
                          },
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} >
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Range To
                    </Typography>
                    <Field
                      as={TextField}
                      size={"small"}
                      type="number"
                      name="rangeTo"
                      placeholder="Enter Range To"
                      fullWidth
                      sx={{
                        ".MuiInputBase-input": {
                          // letterSpacing: "0.2rem",

                          "&::placeholder": {
                            // color: "green",
                            opacity: 1,
                            color: color.placeholderColor,
                            fontSize: "13px",
                          },
                        },
                      }}
                    />
                  </Grid>
                </>
              )}
              <Grid container item xs={12} justifyContent={"flex-end"} gap="1rem">
                <Button
                  onClick={handleCancel}
                  variant="contained"
                  sx={{
                    backgroundColor: color.TableCancelButton,
                    textTransform: "none",
                    color: color.CancelTextColor,
                    ":hover": {
                      backgroundColor: color.TableCancelButton,
                      textTransform: "none",
                      color: color.CancelTextColor,
                    },
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type={"submit"}
                  variant="contained"
                  disabled={loading}
                  sx={{
                    textTransform: "none",
                    backgroundColor: loading ? "default" : color.TableButtonColor,
                    "&:hover": {
                      backgroundColor: loading ? "default" : color.buttonDisable,
                    },
                  }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default MeterModal;